<ui-user-delete
  [alertMessage]="alertMessage"
  (submitResult)="onAccountDeleteSubmit($event)"
></ui-user-delete>
